// import { useNavigate } from "react-router-dom";
// import Card from "../components/Card";
// import SectionTitle from "../components/SectionTitle";

// const aboutUsCardBody = [
//   {
//     title: "About Us",
//     description: [
//       "At Forbes Financial Consultancy Corporation (FFCC), we conduct credit investigation based on ethical values like no other.",
//     ],
//   },
// ];

// const servicesCardBody = [
//   {
//     title: "Services",
//     description: [
//       "We provide credible and reliable information to help you make smart business decisions. Whenever we conduct an investigation or initiate an appraisal, we take an in-depth look at your needs so we can provide you with the quality information you require.",
//     ],
//   },
// ];

// export default function Home() {
//   const navigate = useNavigate();

//   const handleClick = () => {
//     navigate("/about");
//   };

//   return (
//     <div className="d-flex w-100 align-items-center flex-column pt-4 pb-5 ps-lg-3 pe-lg-3 gap-3">
//       <div className="text-center pb-4">
//         <SectionTitle title="Integrity at Work" />
//         <button
//           className="btn bg-secondary btn-link ps-4 pe-4 pt-2 pb-2 rounded fw-semibold"
//           onClick={handleClick}
//         >
//           Read More
//         </button>
//       </div>
//       <div className="d-flex w-100 pb-4 ps-4 pe-4 justify-content-center flex-md-row flex-column gap-md-4 gap-3 h-100 align-items-stretch">
//         <Card
//           image="/assets/building.png"
//           body={aboutUsCardBody}
//           buttonLabel="Know More"
//           link="/about"
//           height="38rem"
//         />
//         <Card
//           image="/assets/model.png"
//           body={servicesCardBody}
//           buttonLabel="Read More"
//           link="/about"
//           height="38rem"
//         />
//       </div>
//     </div>
//   );
// }

import { useNavigate } from "react-router-dom";
import Card from "../components/Card";
import SectionTitle from "../components/SectionTitle";

const aboutUsCardBody = [
  {
    title: "About Us",
    description: [
      "At Forbes Financial Consultancy Corporation (FFCC), we conduct credit investigation based on ethical values like no other.",
    ],
  },
];

const servicesCardBody = [
  {
    title: "Services",
    description: [
      "We provide credible and reliable information to help you make smart business decisions. Whenever we conduct an investigation or initiate an appraisal, we take an in-depth look at your needs so we can provide you with the quality information you require.",
    ],
  },
];

export default function Home() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/about");
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* --- Main Section --- */}
      <div className="flex-grow-1 d-flex flex-column align-items-center pt-4 pb-5 ps-lg-3 pe-lg-3 gap-3">
        <div className="text-center pb-4">
          <SectionTitle title="Integrity at Work" />
          <button
            className="btn bg-secondary btn-link ps-4 pe-4 pt-2 pb-2 rounded fw-semibold"
            onClick={handleClick}
          >
            Read More
          </button>
        </div>

        <div className="d-flex w-100 pb-4 ps-4 pe-4 justify-content-center flex-md-row flex-column gap-md-4 gap-3 h-100 align-items-stretch">
          <Card
            image="/assets/building.png"
            body={aboutUsCardBody}
            buttonLabel="Know More"
            link="/about"
            height="38rem"
          />
          <Card
            image="/assets/model.png"
            body={servicesCardBody}
            buttonLabel="Read More"
            link="/about"
            height="38rem"
          />
        </div>
      </div>

      {/* --- Footer Section --- */}
      <footer className="bg-light text-light w-100 mt-auto pt-5 pb-4 px-4">
        <div className="container text-center text-md-start">
          <div className="row">
            {/* About */}
            <div className="col-md-4 mb-4 text-dark">
              <h5 className="fw-bold text-uppercase mb-3">
                Forbes Financial Consultancy Corporation
              </h5>
              <p>
                Established in 2003, Forbes Financial Consultancy Corporation
                (FFCC)
              </p>
              <p>
                was founded on a core value that remains its guiding principle
                to this day INTEGRITY. From the very beginning, FFCC has been
                committed to delivering high-quality, accurate, and reliable
                financial reports, earning the trust of businesses and financial
                institutions.
              </p>
              <p>
                Over the past 22 years, FFCC has grown into one of the country’s
                fastest growing Credit Information Agencies, providing
                comprehensive business information and consulting services.
              </p>
            </div>

            {/* Contact */}
            <div className="col-md-4 mb-4 text-dark">
              <h6 className="fw-bold mb-3">Contact Us</h6>
              <p>
                Unit 1408 Jollibee Plaza Condominium
                <br />
                F. Ortigas Center, Pasig City
                <br />
                <a
                  href="https://maps.app.goo.gl/KzAbFew1dAkusNBx5"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                >
                  View on Map
                </a>
              </p>
              <p>
                <strong>Tel:</strong> (+632) 910 8115 / (+632) 636 3053
              </p>
              <p>
                <strong>Mobile:</strong> (+63) 997 917 7218 / (+63) 975 584 5454
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:ffcc@forbesfinancial.com.ph"
                  className="text-primary"
                >
                  ffcc@forbesfinancial.com.ph
                </a>
              </p>
              <p>
                <strong>Hours:</strong> Mon–Fri, 8:00 AM – 5:00 PM
              </p>
            </div>

            {/* Social */}
            <div className="col-md-4 mb-4 text-md-end text-dark">
              <h6 className="fw-bold mb-3">Follow Us</h6>
              <p>
                <a
                  href="https://www.facebook.com/profile.php?id=100072035891136"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary me-2"
                >
                  Facebook
                </a>{" "}
                |
                <a
                  href="https://www.linkedin.com/in/forbes-financial-consultancy-corporation-9a7a4816b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary mx-2"
                >
                  LinkedIn
                </a>{" "}
                |
                <a
                  href="https://www.tiktok.com/@ffcc.ortigas"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary ms-2"
                >
                  TikTok
                </a>
              </p>

              <img
                src="/viber_image_2025-10-16_14-24-19-768.png"
                height="350"
              />
            </div>
          </div>

          <hr className="border-secondary" />

          <div className="text-center small text-dark">
            © 2025 Forbes Financial Consultancy Corporation. All Rights
            Reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
